define([
    'jQuery',
    'underscore',
    'library/fcse-countbutton/countButton',
    'library/fcse-compatibility/object',
    'library/fcse-util/paramConverter',
    'library/fcse-util/url'
],
    function($, _, CountButton, Object, ParamConverter, Url) {

        var CountButtonExtended = function (requestHandler, scope, element, options) {
            // Call Constructor of parent class
            CountButton.apply(this, [element, options]);

            // Save local variables
            this.requestHandler = requestHandler;
            this.scope = scope;
            
            // Override Link-Text element
            this.linkText = $('[data-fcse-role="countbutton--text"]');
            
            // Set Link-Counter element
            this.linkCounter = $('[data-fcse-role="countbutton--counter"]');
            this.updateUrl(ParamConverter.toQuery(scope.params));

            // Initialize events
            this._initEventHandling();
        };

        CountButtonExtended.prototype = $.extend(Object.create(CountButton.prototype), {
            /**
             * Initializes event handling
             * @private
             */
            _initEventHandling: function(){
                // Register scope change handler
                this.scope.change($.proxy(this._onScopeChange, this));

                // Register requestHandler
                this.requestHandler.on('success', $.proxy(this._onUpdateSuccess, this));
                this.requestHandler.on('error', $.proxy(this._onUpdateError, this));
            },          
            
            /**
             * Override RegisterClickHandler
             * 
             * @private
             */
            _registerClickHandler : function() {
                this.link.on('click', $.proxy(this._buttonClickHandler, this));
            },      
            
            /**
             * Override RegisterClickHandler
             * 
             * @private
             */            
            setCountText: function (count) {
                if (_.isUndefined(count)) {
                    count = 0;
                }

                // Update count
                this.count = count;
                               
                // Set Link Text
                var text;
                if (count === 1) {
                    text = this.labels.singularPattern;
                } else {
                    text = this.labels.pluralPattern;
                }
                this.linkText.text(text);
                
                // Update Counter
                this.linkCounter.text(count);
                
                // Remove loading
                this.unsetLoading();
                // Toggles enabled/disabled state based on the new value of this.count
                this.toggleEnabled();
            },   
            
            /**
             * Unset loading
             * 
             * @public
             */       
            unsetLoading: function() {
                // Remove Class
                this.link.removeClass("is-loading").children().removeClass('is-hidden');
            },
            
            /**
             * Override SetLoading
             * 
             * @public
             */               
            setLoading: function () {
                // Add Class
                this.link.addClass("is-loading").children().addClass('is-hidden');
            },

            updateUrl: function (params) {
                var routeParams = { };
                var queryParams = params;

                // Change the link on button.
                var url = new Url(this.link.attr("href"));
                var scrollToOffers = url.query.sto;
                url.query = queryParams;
                if (scrollToOffers) {
                    url.query.sto = scrollToOffers;
                }
                url.hash = { };
                this.link.attr("href", url.toString());
                this.toggleEnabled();
            },
            
            /**
             * Button Click Handler
             * 
             * @param event
             * @private
             */            
            _buttonClickHandler: function(event) {
                if (this.count == 0){
                    event.preventDefault();
                } else {
                    var url = $(event.currentTarget).attr('href');

                    if (_.isFunction(this.options.queryUpdater)) {
                        var urlObj = new Url($(event.currentTarget).attr('href'));
                        urlObj.query = this.options.queryUpdater(urlObj.query);
                        url = urlObj.toString();
                    }

                    window.location.href = url;
                }
            },
            
            /**
             * Handler for update loading success
             * @param event
             * @param data
             * @private
             */
            _onUpdateSuccess: function(response, data){
                // Check if ajax response is from updateRoute
                if (data.route !== this.options.updateRoute){
                    return;
                }
                
                this.setCountText(response.html);
            },

            /**
             * Handler for update loading error
             * @param event
             * @private
             */
            _onUpdateError: function(event){
                console.log('Error handling');
            },

            /**
             * Scope change handler
             * @param event
             * @private
             */
            _onScopeChange: function(scope, params){
                // Set loading state
                this.setLoading();
                
                // Update Button
                this.requestHandler.cancel(this.options.updateRoute);
                this.requestHandler.send(this.options.updateRoute, this.scope.getQuery());
                
                // Update Button URL
                this.updateUrl(ParamConverter.toQuery(params));
            }            
        });

        return CountButtonExtended;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/countbutton/countButtonExtended.js